import React from "react"
import ReactDOM from "react-dom"
import "./index.css"
import "bootstrap/dist/css/bootstrap.min.css"
import GA4React from "ga-4-react"
import Routes from "./Routes"
import printProjectVersion from "./utils/version"
import checkIsIframeMode from "./utils/check-iframe"
import GlobalStyles from "./styles/global"
import { version } from "../package.json"
import config from "./environments/generated.config"
import "@fontsource/ropa-sans"

printProjectVersion()
checkIsIframeMode()

const ga4react = new GA4React("G-2911XVFPFH")

const app = async () => {
  if (config.env !== "dev") {
    ga4react.initialize()
  }

  ReactDOM.render(
    <React.StrictMode>
      <GlobalStyles />
      <Routes />
    </React.StrictMode>,
    document.getElementById("root")
  )
}

app()
